import { NavLink } from "react-router-dom";
import { Flex, Box, Text, Spacer, Image } from "@chakra-ui/react";

import appLogo from "../../assets/image/going-solo-logo.png"

function Navbar() {
  return (
    <Box p={4} display={'block'} width={"100%"} boxShadow='lg' position={'absolute'} backgroundColor="#FFFFFF">
      <Flex direction={"row"}>
        <Flex align="center" justifyContent="flex-start">
          <Flex gap={2} align="center" color="#4C4E66">
            <Image
            height={"auto"} width={["25px", "30px", "30px", "35px", "40px", "40px"]}
            src={appLogo}/>
            <Text fontSize={'1.2em'} fontWeight={'bold'} textDecoration={'none'} cursor={'default'} >Going Solo</Text>
          </Flex>
        </Flex>
        <Spacer/>

        <Flex align="center" justifyContent="flex-end" >
          
          <Flex gap={{base:"30px"}} color="#0B51AD" marginRight={{base:'20px'}}>
            <NavLink to="/" style={({ isActive, isPending, isTransitioning }) => {
              return {
                color: isActive ? "#0B51AD" : "#4286F5",
                fontWeight: "bold",
                textDecoration: "none"
              };
            }}>
              <Flex align="center">
                {/* <FaHome /> */}
                <Text ml={1} fontSize={'1.05em'} >Home</Text>
              </Flex>
            </NavLink>
            <NavLink to="/blogs"style={({ isActive, isPending, isTransitioning }) => {
              return {
                color: isActive ? "#0B51AD" : "#4286F5",
                fontWeight: "bold",
                textDecoration: "none"
              };
            }}>
              <Flex align="center">
                {/* <FaBloggerB /> */}
                <Text ml={1} fontSize={'1.05em'} >Blogs</Text>
              </Flex>
            </NavLink>
          </Flex>

        </Flex>
        
      </Flex>
    </Box>
  );
}

export default Navbar;
